import { ADMIN_URL_PREFIX } from 'modules/core/constants';
import { SUBDOMAIN_LS_KEY } from 'modules/auth/constants/auth.const';
import { ROUTER_PATH } from 'router/const/routerPath.const';

import { isAlternativeSsoLink } from './alternativeSso';

const BACKEND_PORT = 8000;
const PROTOCOL = process.env.NODE_ENV === 'development' ? 'http://' : 'https://';

export const getGlobalAdminLink = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return `${PROTOCOL}${ADMIN_URL_PREFIX}${process.env.WDS_SOCKET_HOST}:${BACKEND_PORT}/global-admin/`;
  }

  const domain = getCurrentDomain();

  return `${PROTOCOL}${ADMIN_URL_PREFIX}${domain}/global-admin/`;
};

export const getAdminLink = (subdomain: string): string => {
  const ls_subdomain = localStorage.getItem(SUBDOMAIN_LS_KEY);
  const actual_subdomain = ls_subdomain ? ls_subdomain : subdomain;

  if (process.env.NODE_ENV === 'development') {
    return `${PROTOCOL}${actual_subdomain}.${process.env.WDS_SOCKET_HOST}:${BACKEND_PORT}/admin/`;
  }

  const domain = getCurrentDomain();

  return `${PROTOCOL}${subdomain}.${domain}/admin/`;
};

export const getManagerAdminLink = (subdomain: string): string => {
  const ls_subdomain = localStorage.getItem(SUBDOMAIN_LS_KEY);
  const actual_subdomain = ls_subdomain ? ls_subdomain : subdomain;

  if (process.env.NODE_ENV === 'development') {
    return `${PROTOCOL}${actual_subdomain}.${process.env.WDS_SOCKET_HOST}:${BACKEND_PORT}/manager-admin/`;
  }

  const domain = getCurrentDomain();

  return `${PROTOCOL}${subdomain}.${domain}/manager-admin/`;
};

export const getFullPath = (subdomain: string, path: string): string => {
  const domain = getCurrentDomain();

  if (process.env.NODE_ENV === 'development') {
    return `${PROTOCOL}${subdomain}.${domain}:${process.env.WDS_SOCKET_PORT}${path}`;
  }

  return `${PROTOCOL}${subdomain}.${domain}${path}`;
};

export const getLoginLink = (): string =>
  isAlternativeSsoLink() ? `${ROUTER_PATH.LOGIN}${window.location.search}` : ROUTER_PATH.LOGIN;

export const getCurrentDomain = (): string => {
  const hostname = window.location.hostname.split('.');
  const domain = hostname.slice(-2).join('.');

  return domain;
};
